import classNames from 'classnames'
import { ReactNode } from 'react'
import z from 'zod'
import * as styles from './outline-button.css.ts'

export const OutlineButtonVariantSchema = z.enum(['default', 'subtle'])
export type OutlineButtonVariant = z.infer<typeof OutlineButtonVariantSchema>
export const OutlineButtonStateSchema = z.enum(['active', 'inactive'])
export type OutlineButtonState = z.infer<typeof OutlineButtonStateSchema>
export const OutlineButtonSizeSchema = z.enum(['default', 'small'])
export type OutlineButtonSize = z.infer<typeof OutlineButtonSizeSchema>

type OutlineButtonProps = {
  ref?: React.Ref<HTMLButtonElement>
  variant?: OutlineButtonVariant
  state: OutlineButtonState
  size?: OutlineButtonSize
  className?: string
  children: ReactNode
} & Pick<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick' | 'onKeyDown' | 'disabled' | 'aria-label'>

export const OutlineButton: React.FC<OutlineButtonProps> = ({
  ref,
  variant = 'default',
  state,
  size = 'default',
  className,
  children,
  ...props
}) => (
  <button
    className={classNames(className, styles.button({ state, size, variant }))}
    onMouseDown={e => {
      e.preventDefault()
    }}
    {...props}
    ref={ref}
  >
    {children}
  </button>
)
